export default "__VITE_ASSET__8b6eec3b__"